﻿export class UrlHash {
    /**
     * Obtient Le path de la route située après le hash
     * Exemple : /Home/Index
     * @returns {}
     */
    public static get GetPath(): string {
        let r = UrlHash.GetRoute;
        return this.GetPathFromString(r);
    }

    /**
     * Obtient la liste des valeurs passées dans la Querystring
     * Exemple : /Home/Index/?a=3&b=5 => a=3&b=5
     * @returns tableau de clé valeur.
     */
    public static get GetQueryDatas(): QueryDatas {

        let r = new QueryDatas();
        let q = this.GetQueryString;
        if (q == null) return r;
        let a = q.split("&");

        a.forEach(x => {
            let s = x.split("=");
            let it: IQueryDataItem = {Key: s[0], Value: s[1]};


            r.Add(it);
        });

        return r;
    }

    /**
     * Obtient la querystring complète de la route située après le hash
     * Exemple : /Home/Index/?a=3&b=5 => a=3&b=5
     * @returns {}
     */
    public static get GetQueryString(): string {
        let r = UrlHash.GetRoute;

        if (r.indexOf("?") < 0) return null;
        return r.split("?")[1];
    }

    /**
     * Obtient la route définit après le hash.
     * @returns {}
     */
    public static get GetRoute(): string {

        if (window.location.hash.indexOf("#") < 0) return window.location.href;
        return window.location.hash.split("#")[1];

    }

    public static GetPathFromString = (str: string): string => {

        if (str.indexOf("?") < 0) return str;

        let re = str.split("?")[0];
        if (re[re.length - 1] == "/") re = re.substring(0, re.length - 1);

        return re;

    }
}

export class QueryDatas {
    private items: Array<IQueryDataItem> = [];

    public get IsEmpty(): boolean {
        return (this.items.length == 0);
    }

    public get ToQueryString(): string {
        let s = "";
        this.items.forEach(x => s = x.Key + "=" + x.Value + "&");
        s = s.substr(0, s.length - 1);

        return s;
    }

    public Add = (item: IQueryDataItem): void => {
        if (this.Contains(item.Key) == true) {
            this.Get(item.Key).Value = item.Value;
            return;
        }

        this.items.push(item);
    }

    public Contains = (key: string): boolean => {
        return (this.items.find(x => x.Key.toLowerCase() == key.toLowerCase()) != null)
    }

    public Get = (key: string): IQueryDataItem => this.items.find(x => x.Key.toLowerCase() == key.toLowerCase());
}

export interface IQueryDataItem {
    Key: string;
    Value: any;
}
